import { faMinusCircle } from "@fortawesome/pro-regular-svg-icons/faMinusCircle";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconSubtract: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faMinusCircle} />;
};
